var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ababab",
    width: "22px",
    height: "22px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ababab",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "attachment"), /*#__PURE__*/React.createElement("path", {
    d: "M23.061 13.441c0 0 1.172-0.891 0.281-1.782-0.893-0.891-1.76 0.259-1.76 0.259l-6.969 6.97c0 0-2.103 2.711-3.696 1.070s1.070-3.696 1.070-3.696l9.759-9.76c0 0 2.744-3.023 5.322-0.445 2.578 2.579-0.453 5.329-0.453 5.329l-13.213 13.214c0 0-4.228 4.884-8.143 0.969s1.016-8.095 1.016-8.095l10.034-10.034c0 0 1.125-0.938 0.281-1.782s-1.781 0.281-1.781 0.281l-11.51 11.511c0 0-4.345 4.767 0.508 9.618 4.853 4.853 9.619 0.509 9.619 0.509l15.822-15.823c0 0 3.164-3.493-0.609-7.268s-7.268-0.609-7.268-0.609l-11.61 11.611c0 0-3.49 2.834-0.325 5.998s5.951-0.372 5.951-0.372l7.674-7.673z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.abacb8bec8a8229d463a569366d8a00c.svg";
export { ForwardRef as ReactComponent };